import "./loaders.css";
export const SpinnerSm = () => <span className="loader-sm"></span>;
export const SpinnerLg = () => <span className="loader-lg"></span>;

export const LengthyLoader = () => <span className="loader-lengthy"></span>;

export const TubeLoader = () => <span className="loader-tube"></span>;
export const BallsLoader = () => <span className="loader-balls"></span>;
export const MagnifyGlass = () => <span className="magnify-glass"></span>;
